import { Component, ChangeDetectionStrategy, input, output, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PostureLinkedCase } from '../../../../services/identity-security.service';

@Component({
  selector: 'app-linked-cases-popup',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './linked-cases-popup.component.html',
  styleUrl: './linked-cases-popup.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkedCasesPopupComponent {
  cases = input.required<PostureLinkedCase[]>();
  title = input.required<string>();
  subtitle = input<string>('');
  close = output<void>();

  protected sortedCases = computed<PostureLinkedCase[]>(() =>
    [...this.cases()].sort((a, b) => b.created_time.localeCompare(a.created_time)),
  );

  onClose(): void {
    this.close.emit();
  }
}
